"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var function_1 = require("fp-ts/lib/function");
var Option_1 = require("fp-ts/lib/Option");
var ord_utils_1 = require("./ord.utils");
var Ord_1 = require("fp-ts/lib/Ord");
var Array_1 = require("fp-ts/lib/Array");
var Foldable_1 = require("fp-ts/lib/Foldable");
var ArrayUtils;
(function (ArrayUtils) {
    var getCompareWithDirection = ord_utils_1.OrdUtils.getCompareWithDirection;
    ArrayUtils.findFirst = function (as, p) { return Option_1.fromNullable(as.find(p)); };
    /**
     * @deprecated
     * Use {@link findFirst}
     */
    ArrayUtils.find = function (predicate) { return function (array) {
        return Option_1.fromNullable(array.find(predicate));
    }; };
    ArrayUtils.findLast = function (predicate) { return function (array) {
        var length = array.length;
        if (length === 0) {
            return Option_1.none;
        }
        if (length === 1) {
            return Option_1.some(array[0]);
        }
        for (var i = length - 1; i >= 0; i--) {
            var value = array[i];
            if (predicate(value)) {
                return Option_1.some(value);
            }
        }
        return Option_1.none;
    }; };
    ArrayUtils.findLastIndex = function (predicate) { return function (array) {
        var length = array.length;
        if (length === 0) {
            return Option_1.none;
        }
        if (length === 1) {
            return Option_1.some(0);
        }
        for (var i = length - 1; i >= 0; i--) {
            var value = array[i];
            if (predicate(value)) {
                return Option_1.some(i);
            }
        }
        return Option_1.none;
    }; };
    function sortWithCompare(compare) {
        return function (as) {
            return Array_1.copy(as).sort(compare);
        };
    }
    ArrayUtils.sortWithCompare = sortWithCompare;
    function sortWithDirection(compare) {
        var getCompare = getCompareWithDirection(compare);
        return function (direction) {
            return sortWithCompare(getCompare(direction));
        };
    }
    ArrayUtils.sortWithDirection = sortWithDirection;
    function unique(as) {
        return Array.from(new Set(as));
    }
    ArrayUtils.unique = unique;
    ArrayUtils.member = function (S) { return function (as, a) {
        var predicate = function (e) { return S.equals(e, a); };
        var i = 0;
        var len = as.length;
        for (; i < len; i++) {
            if (predicate(as[i])) {
                return true;
            }
        }
        return false;
    }; };
    ArrayUtils.uniq = function (S) {
        var memberS = ArrayUtils.member(S);
        return function (as) {
            var r = [];
            var len = as.length;
            var i = 0;
            for (; i < len; i++) {
                var a = as[i];
                if (!memberS(r, a)) {
                    r.push(a);
                }
            }
            return len === r.length ? as : r;
        };
    };
    function toArray(value) {
        return Array.isArray(value) ? value : [value];
    }
    ArrayUtils.toArray = toArray;
    ArrayUtils.remove = function (value) { return function (list) {
        return list.filter(function (item) { return item !== value; });
    }; };
    ArrayUtils.toggle = function (value) { return function (list) {
        if (list.includes(value)) {
            return ArrayUtils.remove(value)(list);
        }
        else {
            return list.concat(value);
        }
    }; };
    ArrayUtils.replace = function (value) { return function (newValue) { return function (list) {
        return list.map(function (item) { return (item === value ? newValue : item); });
    }; }; };
    ArrayUtils.empty = [];
    ArrayUtils.constArray = function_1.constant(ArrayUtils.empty);
    ArrayUtils.extent = function (ord) {
        var min = Foldable_1.minimum(Array_1.array, ord);
        var max = Foldable_1.maximum(Array_1.array, ord);
        return function (list) {
            return min(list).chain(function (min) {
                return max(list).map(function (max) { return ({
                    min: min,
                    max: max,
                }); });
            });
        };
    };
    ArrayUtils.filterByExtent = function (ord) { return function (extent) { return function (list) {
        return Array_1.filter(list, Ord_1.between(ord)(extent.min, extent.max));
    }; }; };
    ArrayUtils.splitArrayIntoChunks = function (array, chunkLength) {
        if (array.length <= chunkLength) {
            return [array];
        }
        var res = [];
        for (var i = 0; i < array.length; i += chunkLength) {
            res.push(array.slice(i, i + chunkLength));
        }
        return res;
    };
})(ArrayUtils = exports.ArrayUtils || (exports.ArrayUtils = {}));
